import React, { useEffect, useState, useCallback } from "react";
import IconButton from "@mui/material/IconButton";
import {Button} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useSwipeable } from "react-swipeable";
import { ProjectGet } from "../../api/orgService";
import useApi from "../../api/useApi";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";


const projectsData = [
  // {
  //   id: 'SAP054',
  //   name: 'SOURCE Pacific Drinking Water Project',
  //   theme: 'Adaptation',
  //   location: 'Multiple countries',
  //   partner: 'Asian Development Bank',
  //   value: '45.8m',
  //   beneficiaries: '300.0k',
  //   image: 'https://picsum.photos/900/400?random=4',
  // },
  // {
  //   id: 'SAP053',
  //   name: 'FISH-ADAPT Project',
  //   theme: 'Resilience',
  //   location: 'Island Nation',
  //   partner: 'World Bank',
  //   value: '22.1m',
  //   beneficiaries: '150.0k',
  //   image: 'https://picsum.photos/900/400?random=3',
  // },
  // {
  //   id: 'SAP052',
  //   name: 'SOURCE Pacific Drinking Water Project',
  //   theme: 'Adaptation',
  //   location: 'Multiple countries',
  //   partner: 'Asian Development Bank',
  //   value: '45.8m',
  //   beneficiaries: '300.0k',
  //   image: 'https://picsum.photos/900/400?random=2',
  // },
  // {
  //   id: 'SAP051',
  //   name: 'FISH-ADAPT Project',
  //   theme: 'Resilience',
  //   location: 'Island Nation',
  //   partner: 'World Bank',
  //   value: '22.1m',
  //   beneficiaries: '150.0k',
  //   image: 'https://picsum.photos/900/400?random=1',
  // },
  {
    id: 1,
    name: "Ponya Mtoto Project",
    location: "Kenya",
    story: "The Ponya Mtoto Project was a comprehensive implementation research initiative designed to reduce newborn deaths from Possible Serious Bacterial Infection (PSBI) in Kenya. Implemented between 2017 and 2021, the project addressed a critical gap in neonatal care by demonstrating that sick young infants can be effectively treated at primary healthcare facilities when hospital referral is not feasible. The Problem Kenya's neonatal mortality rate has remained stubbornly high at 22 deaths per 1,000 live births for the past 30 years, with sepsis accounting for 20% of these deaths. Traditional WHO treatment protocols required hospitalization and injectable antibiotics, but clinical trials revealed that 89% of caregivers in Kenya refused hospital referral due to distance, cost, cultural beliefs, and poor care-seeking behaviors. This left countless sick infants without life-saving treatment. The Solution The Ponya Mtoto Project implemented the 2015 WHO PSBI Guidelines, which introduced simplified antibiotic regimens that trained healthcare providers could administer at primary health facilities when referral was not feasible. The project used implementation research to understand what worked, what didn't, and how to improve care delivery through a comprehensive health systems approach. Implementation Sites The project operated in four counties across Kenya:  Bungoma County (Webuye West and Tongaren Sub-Counties) Turkana County (Turkana Central and Turkana West Sub-Counties) Mombasa County (Mvita and Changamwe-Jomvu Sub-Counties) Kilifi County (Kilifi North and Kaloleni Sub-Counties)  A total of 48 health facilities participated, including 10 hospitals, 18 health centers, and 20 dispensaries. Key Partners The project brought together multiple stakeholders:  Fountain Africa Trust (Alice Natecho - Implementation Partner) Population Council (Research Lead) Kenya Paediatric Research Consortium (KEPRECON) Mount Kenya University (MKU) Ministry of Health - Division of Neonatal and Child Health County and Sub-County Health Management Teams.\n\nThe project was structured in three phases:  Phase 1: National and county consultation and stakeholder engagement Phase 2: Implementation research in the four project counties (2018-2020) Phase 3: Dissemination of findings and policy advocacy (2021)  Baseline Assessment (2018) A formative assessment identified critical barriers:  Supply-side: Inadequate provider knowledge, poor supervision, frequent drug stockouts, weak governance Demand-side: Poor accessibility, cultural barriers, myths about childhood illness, decision-making delays  Interventions Implemented At Policy Level:  Integrated PSBI treatment into national IMNCI guidelines Revised under-5 registers to capture infant indicators.\nAt County Level:  Developed technical briefs for advocacy and resource allocation Improved drug supply chains for essential antibiotics  At Facility Level:  Trained 50 healthcare facilities on IMNCI/PSBI protocols Strengthened quality improvement teams Distributed job aids, flowcharts, and caregiver pamphlets  At Community Level:  Equipped Community Health Volunteers (CHVs) to recognize danger signs Strengthened community-facility referral linkages Created demand for services through awareness campaigns  Capacity Building Innovation:  Established the Kenya Community of Practice (KCoP) - an online platform hosted on the Kenya Paediatric Association website for continuous professional development, peer learning, and data sharing  \n\n\nKey Results 1. Policy Integration  PSBI guidelines successfully incorporated into national IMNCI protocols MOH revised newborn registers and DHIS2 reporting tools nationwide IMNCI/PSBI activities included in national work plans  2. Feasibility and Acceptability  1,550 sick young infants treated across all facilities during monitoring period Gradual increase in PSBI cases identified and treated at primary healthcare level Providers found simplified antibiotic regimen (Amoxicillin DT and Gentamicin) easy to administer 90% of facilities rated the treatment approach as \"highly appropriate\"  3. Increased Utilization  Significant improvement in classification and documentation of sick young infants Community-facility referrals increased progressively over project duration Stockouts of essential antibiotics (Amoxicillin-DT) reduced dramatically Provider training scores improved from baseline to endline  4. Sustainability  PSBI integrated into facility work plans, budgets, and procurement systems Quality Improvement Teams became more functional across facilities On-the-job training and continuous medical education incorporated IMNCI/PSBI content  Humanitarian Response Elements The Ponya Mtoto Project demonstrated strong humanitarian response characteristics:  Life-saving interventions for vulnerable newborns in resource-limited settings Equity-focused approach reaching marginalized communities in rural counties Crisis response to Kenya's persistent neonatal mortality emergency Community-based surveillance through CHVs for early detection and referral Simplified treatment protocols enabling timely care when hospital referral impossible  Challenges Identified Despite successes, persistent challenges remained:  Negative socio-cultural beliefs affecting care-seeking behavior Long distances and limited transport options Poor adherence to follow-up visits (Days 4 and 8) Inadequate funding for support supervision Limited continuous professional development opportunities COVID-19 pandemic disruptions  Lessons Learned  County support is critical - CHMTs and SCHMTs must actively support facility and community services Primary care reduces referral burden - Proper management at lower-level facilities significantly reduces hospital referrals Blended capacity building works - Combining on-the-job training, workshops, and online platforms drives improvement CHVs are essential - Community Health Volunteers create strong linkages and facilitate timely care-seeking Simplified regimens reduce barriers - Easier antibiotic administration allows caregivers to manage other household responsibilities  Project Impact The Ponya Mtoto Project successfully demonstrated that managing sick young infants with PSBI at primary healthcare facilities is feasible, acceptable, and sustainable in Kenya. By addressing systemic barriers through a comprehensive health systems approach, the project has contributed to national policy change and created a replicable model for reducing preventable newborn deaths across the country. The project's evidence-based approach and collaborative partnerships have positioned Kenya to scale up IMNCI/PSBI programming nationally, bringing life-saving care closer to communities and ultimately contributing to the country's goal of reducing neonatal mortality to 12 per 1,000 live births by 2030.",
    image: "https://file.fountainafrica.org/wp-content/uploads/2025/11/Screenshot%202025-11-15%20011026.png",
    
},
{
    id: 3,
    name: "Austin Project",
    location: "Bungoma",
    story: "Austin Kibeti was born in July 2010 and was diagnosed with Autism Spectrum Disorder in 2013 when he turned 3 years. He attended City Primary School Autism Unit in Nairobi from 2015, up to Integrated Class 2. The Autism Unit is housed in a public primary school for low income families located on the Eastern part of Nairobi. The Unit offers integrated education and therapeutic services to children with Autism Spectrum Disorder, Downs Syndrome and other neurological disorders associated with speech, learning and other life skills.  Unfortunately, the Ministry of Education does not provide extra finances to schools to cater for the special needs of autistic children. The Special Unit therefore disintegrated. Austin’s parents decided to relocate from Nairobi to Bungoma County. In Bungoma, there are no programs for autistic children, the community is not aware that children with ASD can go to school and acquire skills for them to live a normal life. They are considered either mentally retarded or schizophrenic.",
    image: "https://file.fountainafrica.org/wp-content/uploads/2025/11/IMG-20151004-WA0006.jpg",
},
  {
    id: 4,
    name: 'Community Midwifery Project', // name
    theme: 'Resilience', //description
    location: 'Lodware Kenya', // location
    partner: 'World Bank',  // to add
    value: '22.1m',
    beneficiaries: '150.0k',
    image: 'https://file.fountainafrica.org/wp-content/uploads/2020/01/Her-Excellency-The-first-Lady-Margaret-Kenyatta-Visit-Birth-Wise-Stand-in-Beyond-Zero-Campaign-launch-in-Bungoma-County-1-768x420.jpg',
  },
  // Add more project items...
];

export default function ProjectCarousel() {

  const navigate = useNavigate()


  const [projects,setAllProjects] = useState(projectsData)
  const { request: getAllProjects, data:projectData, error:projectError} = useApi(ProjectGet);
  
  
  const [activeIndex, setActiveIndex] = useState(projects.length - 1); // Start at the top

  const canGoNext = activeIndex < projects.length - 1;
  const canGoPrev = activeIndex > 0;

  const next = useCallback(() => {
    if (canGoNext) {
      setActiveIndex((prev) => prev + 1);
    }
  }, [canGoNext]);

  const prev = useCallback(() => {
    if (canGoPrev) {
      setActiveIndex((prev) => prev - 1);
    }
  }, [canGoPrev]);

  // ⌨️ Keyboard support
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [prev, next]);

  // 🤏 Swipe support
  const handlers = useSwipeable({
    onSwipedLeft: () => next(),  // swipe left → go forward
    onSwipedRight: () => prev(), // swipe right → go back
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });


  useEffect(() => {
    getAllProjects();
         // eslint-disable-next-line
    }, []);
    
    useEffect(()=>{
      if (projectData?.status===200) {
        setAllProjects(projectData?.data?.results);
        setActiveIndex(projectData?.data?.results?.length - 1)
      }
    // eslint-disable-next-line
    },[projectData])

    

    // useEffect(()=>{
    //     if(location?.state?.refresh==="org"){
    //       getAllProjects();
    //     }
    //   // eslint-disable-next-line
    //   },[location?.state])
  
    useEffect(()=>{
        if(projectError){
            toast.error(`${JSON.stringify(projectError?.response?.data,null,2)}`,{position: "top-center"});
      }
    },[projectError])

  return (
    <div className="carousel-stack-container">
      {/* Left nav */}
      <div className="nav-button-container left">
        {canGoPrev && (
          <IconButton onClick={prev} color="primary">
            <ArrowBackIosNewIcon />
          </IconButton>
        )}
      </div>

      {/* Stack */}
      <div className="carousel-stack-wrapper" {...handlers}>
        {projects?.length>0?
        
        (projects?.map((project, index) => {
          const offset = index - activeIndex;

          if (offset > 0) return null;

          const style = {
            transform: `translateX(${offset * 60}px) scale(${1 + offset * 0.09})`,
            opacity: 1 + offset * 0.2,
            zIndex: index,
          };

          return (
            <div
              key={project?.id}
              className={`stack-card ${offset === 0 ? "active" : ""}`}
              style={{ ...style, backgroundImage: `url(${project?.image})` }}
            >
              {/* {offset === 0 && ( */}
                <div className="stack-title">{project?.name}</div>
              {/* )} */}
            </div>
          );
        })):""}
      </div>

      {/* Side Info Panel */}
      <div className="stack-details-panel">
        <h2>{projects[activeIndex]?.name}</h2>
        {/* <p><strong>Theme:</strong> {projects[activeIndex].theme}</p> */}
        <p><strong>Location:</strong> {projects[activeIndex]?.location}</p>
        {/* <p><strong>Partner:</strong> {projects[activeIndex].partner}</p> */}
        {/* <p><strong>Total Project Value:</strong> {projects[activeIndex].value}</p> */}
        {/* <p><strong>Beneficiaries:</strong> {projects[activeIndex].beneficiaries}</p> */}

          <Link
            to={`/projects/${projects[activeIndex]?.name}/${projects[activeIndex]?.id}/`}
            state={{ projectId: projects[activeIndex]?.id, projectName: projects[activeIndex]?.name,subcategory: projects[activeIndex]?.subcategory }}
            // className="campaign-btn inline-block text-white bg-blue-600 px-4 py-2 rounded-md hover:bg-blue-700"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              backgroundColor: "#22C55E", // green
              color: "white",
              padding: "10px 20px",
              borderRadius: "9999px",
              fontWeight: "600",
              fontSize: "16px",
              border: "none",
              cursor: "pointer",
              transition: "background-color 0.2s ease"
            }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#c18078")} // blue-600
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#22C55E")} // green
          >
            View Project →
          </Link>

      </div>

      {/* Right nav (AFTER panel) */}
      <div className="nav-button-container right">
        {canGoNext && (
          <IconButton onClick={next} color="primary">
            <ArrowForwardIosIcon />
          </IconButton>
        )}
      </div>
    </div>
  );
}